import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareBehindSquare3"><Path fillRule="evenodd" clipRule="evenodd" d="M16 8V2H2V16H8V22H22V8H16ZM9.5 16H16V9.5H20.5V20.5H9.5V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
